
<div class="kazaplan-menu">
    <div class="kazaplan-menu__content">
        
        <ul  (mouseleave)="onMouseLeave()">
            <li class="kz-header-nav-link" (mouseenter)="underlineLink($event)" (mouseleave)="removeUnderline()" data-underline-color="#88B04B" >
                <a [routerLink]="['/kazacafe'] | localize" class="kazaplan-menu__link" appGtmTrack="menu_kzp_community_0" target="_blank">Communauté</a>
            </li>
            <li (click)="openb=true;" (mouseleave)="openb=false;" class="kz-header-nav-link" (mouseenter)="underlineLink($event)" (mouseleave)="removeUnderline()" data-underline-color="#004DB3" >
                <span class="kazaplan-menu__link" appGtmTrack="menu_kzp_services_0" >Nos services</span>
                <div class="kz-header-submenu kz-header-submenu--pro">
                    <div class="kz-header-submenu-content" [@layerAnimationD]="(openb)? 'open' : 'closed'">
                        <img src="https://tinykozi.io/img_290b573" height="1" width="1" *ngIf="openb===true" style="display:none"/>
                        <a [routerLink]="['/pro'] | localize" class="card card--pro"   appGtmTrack="menu_kzp_services_cta_annuaire" target="_blank">
                            <div class="card__title">
                                L'annuaire
                            </div>
                            <div class="card__subTitle">
                                des professionels
                            </div>
                            <div class="card__subTitle">
                                de la décoration
                            </div>
                        </a>
                        <a [routerLink]="['/3d-home-design-software','design-by-a-professional'] | localize" class="card card--tender"  appGtmTrack="menu_kzp_services_cta_decorateur"  target="_blank">
                            <div class="card__title">
                                Un décorateur
                            </div>
                            <div class="card__subTitle">
                                conçoit votre plan 3D
                            </div>
                            <div class="card__subTitle">
                                dès 89€
                            </div>
                        </a>
                        <app-good-deals-menu parentMenu="menu_kzp_services" *ngFor="let dealArea of dealsPro" [dealArea]="dealArea"></app-good-deals-menu>
                    </div>
                </div>
            </li>
            <li (click)="openc=true;" (mouseleave)="openc=false;" class="kz-header-nav-link" (mouseenter)="underlineLink($event)" (mouseleave)="removeUnderline()" data-underline-color="#EE6400" >
                <span class="kazaplan-menu__link" appGtmTrack="menu_kzp_good_deals_0">Bons plans</span>
                <div class="kz-header-submenu kz-header-submenu--offers">
                    <div class="kz-header-submenu-content" [@layerAnimationD]="(openc)? 'open' : 'closed'">
                        <img src="https://tinykozi.io/img_6a353ac" height="1" width="1" *ngIf="openc===true" style="display: none"/>
                        <a [routerLink]="['/home-garden-deals'] | localize" class="card card--goodDeal"  appGtmTrack="menu_kzp_good_deals_cta"  target="_blank">
                            <div class="card__subTitle">
                                Tous les
                            </div>
                            <div class="card__title">bons plans
                            </div>
                        </a>
                        <app-good-deals-menu parentMenu="menu_kzp_good_deals" *ngFor="let dealArea of dealsOffers" [dealArea]="dealArea"></app-good-deals-menu>
                    </div>
                </div>
            </li>
        </ul>
        
        <span class="kz-header-nav--underline"></span>
    </div>
   
    
</div>
<div class="burger-menu" (click)="toggleSidebar()">
  <span></span>
  <span></span>
  <span></span>
</div>
<div class="sidebar" [ngClass]="{'sidebar--open': isSidebarOpen}" >
    <button type="button" class="kz-header-menu-close" (click)="toggleSidebar()">
        <kz-icons name="cross"></kz-icons>
        <ng-container i18n="@@features.header.resp.verticalMenu.closeCTA">Close</ng-container>
      </button>
    <ul class="header-nav">
        <li >
            <a [routerLink]="['/kazacafe'] | kzLocalize" target="_blank"   class="header-submenu kz-header-submenu--coaching">
              <div class="submenu-content">
                <div class="submenu-grid">
                  <div class="submenu-item">
                    <kz-icons name="community" inline="true"></kz-icons>
                    <p class="submenu-head-title" i18n="@@features.header.nav.community" >Community</p>
                    <kz-icons name="arrowright"></kz-icons>
                  </div>
                </div>
              </div>
            </a>
          </li>
        <li >
            <a [routerLink]="['/pro'] | kzLocalize" target="_blank" class="header-submenu kz-header-submenu--coaching">
              <div class="submenu-content">
                <div class="submenu-grid">
                  <div class="submenu-item">
                    <kz-icons name="coaching" inline="true"></kz-icons>
                    <p class="submenu-head-title" >Nos services</p>
                    <kz-icons name="arrowright"></kz-icons>
                  </div>
                </div>
              </div>
            </a>
          </li>
        <li >
            <a [routerLink]="['/home-garden-deals'] | kzLocalize" target="_blank" appGtmTrack="menu_kzp_gooDeal_0"  class="header-submenu kz-header-submenu--coaching">
              <div class="submenu-content">
                <div class="submenu-grid">
                  <div class="submenu-item">
                    <kz-icons name="loan_granted" inline="true"></kz-icons>
                    <p class="submenu-head-title" i18n="@@features.header.nav.goodDeals.title">Good deals</p>
                    <kz-icons name="arrowright"></kz-icons>
                  </div>
                </div>
              </div>
            </a>
          </li>
          
        
        <!-- Add more navigation items as needed -->
    </ul>
</div>
